import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { setupNativeExperience } from './lib/nativeLinks';
import { initGA } from './lib/analytics';

// Lazy-load Sentry after first paint to reduce initial bundle by ~190KB
const initSentry = () => {
  import('@sentry/react').then((Sentry) => {
    import('./config/sentry').then(({ SENTRY_DSN, SENTRY_TRACES_SAMPLE_RATE, SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, SENTRY_REPLAYS_SESSION_SAMPLE_RATE }) => {
      if (!SENTRY_DSN) return;
      // Register Sentry with our centralized logError helper so subsequent
      // logError() calls forward to Sentry in addition to console.
      import('./lib/logError').then(({ _registerSentry }) => _registerSentry(Sentry));

      Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
        ],
        tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
        replaysSessionSampleRate: SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        beforeSend(event) {
          try {
            if (event.request?.headers) {
              const h: Record<string, any> = event.request.headers as any;
              delete h['authorization'];
              delete h['x-client-info'];
              delete h['apikey'];
            }
            if (event.request?.url) {
              try {
                const url = new URL(event.request.url);
                url.search = '';
                event.request.url = url.toString();
              } catch {}
            }
            if (event.user) {
              if ('email' in (event.user as any)) (event.user as any).email = '[redacted]';
              if ('username' in (event.user as any)) (event.user as any).username = '[redacted]';
            }
            if (event.breadcrumbs) {
              event.breadcrumbs = event.breadcrumbs.map((b) => {
                if (b?.data && typeof b.data === 'object') {
                  const d: Record<string, any> = { ...(b.data as any) };
                  for (const k of Object.keys(d)) {
                    if (/(authorization|token|apikey|password)/i.test(k)) d[k] = '[redacted]';
                  }
                  return { ...b, data: d };
                }
                return b;
              });
            }
          } catch {}
          return event;
        },
      });
    });
  });
};

// Defer Sentry init until after first paint
if ('requestIdleCallback' in window) {
  requestIdleCallback(initSentry);
} else {
  setTimeout(initSentry, 2000);
}

// Initialize analytics
initGA();

setupNativeExperience();
createRoot(document.getElementById("root")!).render(<App />);
